import { DISABLED, MANDATORY, OPTIONAL } from 'model/ticket/collection/note/type'

/**
 * Schenck's note types
 */
export default [
  // normal types
  {
    key: 'blank',
    value: 'Blank note',
    color: '',
    selectable: true,
    mandatory: false,
    timeTracking: DISABLED,
  },
  {
    key: 'processingStep',
    value: 'Processing Step',
    color: '',
    selectable: true,
    mandatory: false,
    timeTracking: OPTIONAL,
    startDate: DISABLED,
  },
  {
    key: 'birth',
    value: 'Birth note',
    color: 'primary',
    selectable: false,
    mandatory: false,
    timeTracking: DISABLED,
    startDate: DISABLED,
  },
  {
    key: 'hotline',
    value: 'Hotline',
    color: 'warning',
    mandatory: false,
    timeTracking: OPTIONAL,
    startDate: OPTIONAL,
  },
  // synthetic types
  {
    key: 'timeEntry',
    value: 'Time entry',
    color: '',
    selectable: false,
    mandatory: true,
    timeTracking: MANDATORY,
    startDate: MANDATORY,
  },
  // quick action types
  {
    key: 'forward',
    value: 'Forwarded to {team}',
    color: 'primary',
    mandatory: {
      onSuccess: MANDATORY,
      onFail: DISABLED,
      rules: {
        status: [50],
        assignee: true, // I am assignee
      },
    },
    timeTracking: {
      onSuccess: MANDATORY,
      onFail: DISABLED,
      rules: {
        status: [50],
        assignee: true, // I am assignee
      },
    },
    startDate: DISABLED,
  },
  {
    key: 'assign',
    value: 'Assigned to {assignee}',
    color: 'primary',
    mandatory: {
      onSuccess: MANDATORY,
      onFail: DISABLED,
      rules: {
        status: [50],
        assignee: true, // I am assignee
      },
    },
    timeTracking: {
      onSuccess: MANDATORY,
      onFail: DISABLED,
      rules: {
        status: [50],
        assignee: true, // I am assignee
      },
    },
    startDate: DISABLED,
  },
  {
    key: 'unassign',
    value: 'Unassigned from {assignee}',
    color: 'primary',
    mandatory: {
      onSuccess: MANDATORY,
      onFail: DISABLED,
      rules: {
        status: [50],
        assignee: true, // I am assignee
      },
    },
    timeTracking: {
      onSuccess: MANDATORY,
      onFail: DISABLED,
      rules: {
        status: [50],
        assignee: true, // I am assignee
      },
    },
    startDate: DISABLED,
  },
  {
    key: 'postpone',
    value: 'Postponed until {date}',
    color: 'warning',
    mandatory: true,
    timeTracking: MANDATORY,
    startDate: DISABLED,
  },
  {
    key: 'postpone_customer',
    value: 'Waiting for customer until {date}',
    color: 'warning',
    mandatory: true,
    timeTracking: MANDATORY,
    startDate: DISABLED,
  },
  {
    key: 'postpone_third_party',
    value: 'Waiting for third party until {date}',
    color: 'warning',
    mandatory: true,
    timeTracking: MANDATORY,
    startDate: DISABLED,
  },
  {
    key: 'close_resolve',
    value: 'Issue resolved',
    color: 'success',
    mandatory: true,
    timeTracking: MANDATORY,
    startDate: DISABLED,
  },
  {
    key: 'close_cancel',
    value: 'Issue cancelled',
    color: 'success',
    mandatory: true,
    timeTracking: MANDATORY,
    startDate: DISABLED,
  },
  {
    key: 'reopen',
    value: 'Issue reopened',
    color: 'primary',
    mandatory: true,
    timeTracking: DISABLED,
    startDate: DISABLED,
  },
  {
    key: 'stop',
    value: 'Stop',
    color: 'disabled',
    mandatory: true,
    timeTracking: MANDATORY,
    startDate: DISABLED,
  },
]
